/**
 * @generated SignedSource<<a406d2c2123128534bab206f180cef57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EventTimeType = "Date" | "DateTime" | "%future added value";
export type Inconveniences = "External" | "MissedLunch" | "NoMeetingRelief" | "OnNoMeetingDay" | "Other" | "OutsideMeetingHours" | "OutsideWorkingHours" | "Uncrawled" | "%future added value";
export type SchedulingAttendanceSummaryTag = "Best" | "Conflict" | "Current" | "Good" | "InFocusTime" | "Inconvenient" | "MostFocus" | "OverLunch" | "Soonest" | "%future added value";
export type SchedulingResponseQualifier = "NoConvenientTimesWithRooms" | "%future added value";
export type Unavailabilities = "FarOutsideWorkingHours" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventSchedulerTimeInput_schedulingResponseErrorable$data = {
  readonly __typename: "SchedulingResponse";
  readonly uncrawledCalendars: ReadonlyArray<string | null>;
  readonly qualifiers: ReadonlyArray<SchedulingResponseQualifier | null> | null;
  readonly queryRecommendation: {
    readonly minutesDuration: string | null;
    readonly availableDate: string | null;
  } | null;
  readonly slots: ReadonlyArray<{
    readonly summary: {
      readonly availableRooms: ReadonlyArray<string>;
      readonly tags: ReadonlyArray<SchedulingAttendanceSummaryTag | null> | null;
      readonly freeAttendees: ReadonlyArray<string>;
      readonly inconvenientForAttendees: ReadonlyArray<string>;
      readonly unavailableAttendees: ReadonlyArray<string>;
      readonly focusTimeMinutesCost: number;
      readonly conflictingAttendees: ReadonlyArray<string>;
    };
    readonly attendanceImpacts: ReadonlyArray<{
      readonly hasConflict: boolean;
      readonly calendarId: string;
      readonly focusTimeMinutesCost: number;
      readonly inconveniences: ReadonlyArray<Inconveniences>;
      readonly unavailabilities: ReadonlyArray<Unavailabilities>;
      readonly conflictingMeetings: ReadonlyArray<string>;
    }>;
    readonly roomImpacts: ReadonlyArray<{
      readonly roomId: string;
      readonly available: boolean;
    }>;
    readonly timeRange: {
      readonly id: string;
      readonly startTime: {
        readonly type: EventTimeType;
        readonly dateOrDateTime: string;
        readonly timeZone: string | null;
        readonly offsetMinutes: number | null;
        readonly millis: number;
      } | null;
      readonly endTime: {
        readonly type: EventTimeType;
        readonly dateOrDateTime: string;
        readonly timeZone: string | null;
        readonly offsetMinutes: number | null;
        readonly millis: number;
      } | null;
    } | null;
    readonly additionalChanges: ReadonlyArray<{
      readonly organizer: any;
      readonly event: {
        readonly id: string;
        readonly externalEventId: string;
        readonly events: ReadonlyArray<{
          readonly id: string;
          readonly title: string | null;
          readonly startTime: {
            readonly dateOrDateTime: string;
          };
          readonly endTime: {
            readonly dateOrDateTime: string;
          };
        }>;
      } | null;
      readonly from: any;
      readonly to: any;
    }>;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"EventSchedulerSuggestedTimes_schedulingResponse">;
  readonly " $fragmentType": "EventSchedulerTimeInput_schedulingResponseErrorable";
} | {
  readonly __typename: "GraphEntityError";
  readonly message: string | null;
  readonly statusCode: number | null;
  readonly body: string | null;
  readonly " $fragmentType": "EventSchedulerTimeInput_schedulingResponseErrorable";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "EventSchedulerTimeInput_schedulingResponseErrorable";
};
export type EventSchedulerTimeInput_schedulingResponseErrorable$key = {
  readonly " $data"?: EventSchedulerTimeInput_schedulingResponseErrorable$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSchedulerTimeInput_schedulingResponseErrorable">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "focusTimeMinutesCost",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dateOrDateTime",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "timeZone",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "offsetMinutes",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "millis",
    "storageKey": null
  }
],
v4 = [
  (v2/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSchedulerTimeInput_schedulingResponseErrorable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventSchedulerSuggestedTimes_schedulingResponse"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uncrawledCalendars",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "qualifiers",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "QueryRecommendation",
          "kind": "LinkedField",
          "name": "queryRecommendation",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minutesDuration",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "availableDate",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SchedulingSlot",
          "kind": "LinkedField",
          "name": "slots",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SchedulingAttendanceSummary",
              "kind": "LinkedField",
              "name": "summary",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "availableRooms",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tags",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "freeAttendees",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "inconvenientForAttendees",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "unavailableAttendees",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "conflictingAttendees",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SchedulingAttendanceImpact",
              "kind": "LinkedField",
              "name": "attendanceImpacts",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasConflict",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "calendarId",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "inconveniences",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "unavailabilities",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "conflictingMeetings",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SchedulingRoomImpact",
              "kind": "LinkedField",
              "name": "roomImpacts",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "roomId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "available",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeRange",
              "kind": "LinkedField",
              "name": "timeRange",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventTime",
                  "kind": "LinkedField",
                  "name": "startTime",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventTime",
                  "kind": "LinkedField",
                  "name": "endTime",
                  "plural": false,
                  "selections": (v3/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SchedulingMove",
              "kind": "LinkedField",
              "name": "additionalChanges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "organizer",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventParent",
                  "kind": "LinkedField",
                  "name": "event",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "externalEventId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Event",
                      "kind": "LinkedField",
                      "name": "events",
                      "plural": true,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "title",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "EventTime",
                          "kind": "LinkedField",
                          "name": "startTime",
                          "plural": false,
                          "selections": (v4/*: any*/),
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "EventTime",
                          "kind": "LinkedField",
                          "name": "endTime",
                          "plural": false,
                          "selections": (v4/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "from",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "to",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "SchedulingResponse",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "body",
          "storageKey": null
        }
      ],
      "type": "GraphEntityError",
      "abstractKey": null
    }
  ],
  "type": "SchedulingResponseErrorable",
  "abstractKey": "__isSchedulingResponseErrorable"
};
})();

(node as any).hash = "c6ccd45dd11e85517cd16b286bbf61f9";

export default node;
